import React from "react"
import { styled, useTheme } from "@mui/material"

const Image = styled("img")(() => ({}))

export const HeaderLogo = () => {
  const theme = useTheme()
  const { logo } = theme.assets || {}
  const styleOverrides = theme.components[`AppHeader`]?.styleOverrides || {}
  const { logoImage } = styleOverrides

  return logo && <Image src={logo.url} alt="Logo Header" sx={logoImage} />
}
